"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _LoadingIndicator = _interopRequireDefault(require("../../../../components/LoadingIndicator"));

var _PDFHandler = _interopRequireDefault(require("../../../containers/CampaignCreator/PDFHandler"));

var _TxtHandler = _interopRequireDefault(require("../../../containers/CampaignCreator/TxtHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function StreamRadio(_ref) {
  var _ref$stream = _ref.stream,
      id = _ref$stream.id,
      value = _ref$stream.percentage,
      name = _ref$stream.name,
      currentStream = _ref.currentStream,
      indexThreshold = _ref.indexThreshold,
      handleRadioChange = _ref.handleRadioChange,
      showDownload = _ref.showDownload,
      isFetching = _ref.isFetching;
  // $FlowFixMe
  var buttonRef = (0, _react.useRef)(null);
  var rect = {
    width: 105,
    height: 30
  };

  if (buttonRef.current && showDownload) {
    rect = buttonRef.current.getBoundingClientRect();
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Form.Field, {
    key: id,
    className: "message-stream--radio-field"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Radio, {
    className: "message-streams--radio",
    disabled: value === 0 ? true : false,
    label: isFetching ? /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
      className: "message-streams--radio-label"
    }, /*#__PURE__*/_react["default"].createElement("span", null, name), /*#__PURE__*/_react["default"].createElement("span", {
      className: "message-streams--quad-value"
    }, Math.round(value * 10) / 10, "% of Audience"), ' '), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: showDownload ? rect.width : '',
        height: showDownload ? '34px' : ''
      }
    })),
    name: "messageStreams",
    value: id,
    checked: currentStream === id,
    onChange: handleRadioChange
  }), showDownload ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "message-stream--downloads-container",
    ref: buttonRef
  }, /*#__PURE__*/_react["default"].createElement(_PDFHandler["default"], {
    quadId: id,
    name: name,
    indexThreshold: indexThreshold,
    disabled: value === 0 ? true : false
  }), /*#__PURE__*/_react["default"].createElement(_TxtHandler["default"], {
    quadId: id,
    name: name,
    indexThreshold: indexThreshold,
    disabled: value === 0 ? true : false
  })) : '');
}

var _default = StreamRadio;
exports["default"] = _default;